import React from 'react';
import { 
	func, 
	object,
	bool
} from 'prop-types';
import ReactMarkdown from 'react-markdown';
import {QuizSentence,QuizSentenceBase} from '../../molecules/QuizSentence/index';
import style from './style';

const SamplePresenter = ({
	quizContentProps,
	...props
}) =>{
	if(!quizContentProps){
		return <style.Sample.Wrapper {...props}>
			<style.Sample.NoSampleLogo >No Sample</style.Sample.NoSampleLogo>
		</style.Sample.Wrapper>;
	}
	
	const { 
		quiz,
		isLastQuestion, 
		openAnswer,
		onNext,
		onBack,
		onOpenAnswer
	} = quizContentProps;
	
	return (
		<style.Sample.Wrapper {...props}>
			<style.h4>Question</style.h4>
			<style.QuestionWrapper>
				<ReactMarkdown 
					source={quiz.question}
					renderers={{text:function Renderer(props){
						return openAnswer ? <QuizSentenceBase
							content={props.children} 
							renderBlank={({answer})=>(<style.Sample.AnswerText key={answer}>{answer}</style.Sample.AnswerText>)}
						/> : <QuizSentence
							options={quiz.options}
							content={props.children} 
							onAnnotation={(answer)=>{
								return quiz.answers ? 
									1 + quiz.answers.findIndex((a=>a===answer)) : 0;
							}} 
						/>;}}}
				/>
			</style.QuestionWrapper>
			<style.Sample.AnswerButtonWrapper>
				<style.Sample.TextButton onClick={()=>{onOpenAnswer(!openAnswer);}}><style.Sample.SearchIcon/>Answer</style.Sample.TextButton>
			</style.Sample.AnswerButtonWrapper>
			<style.Sample.NextPrevWrapper>
				<style.Sample.PrevButton disabled={quiz.number===1} onClick={onBack}>BACK</style.Sample.PrevButton>
				<style.Sample.NextButton disabled={isLastQuestion} onClick={onNext}>NEXT</style.Sample.NextButton>
			</style.Sample.NextPrevWrapper>
		</style.Sample.Wrapper>
	);
};

SamplePresenter.propTypes = {
	quizContentProps : object,
	isLastQuestion : bool,
	quiz : object,
	onNext : func,
	onBack : func,
};

export default SamplePresenter;